import React, {Component} from 'react';
import {showAxiosError} from "../../helper/helper";
import {request} from "../../helper/APIUtils";
import '../../local_node_modules/react-select/dist/react-select.css';
import 'react-datetime/css/react-datetime.css';
import 'moment/locale/tr';
import GetFromConnectorModal from "./GetFromConnectorModal";
import GetFromConnectorModalWs from "./GetFromConnectorModalWs";
import GetEdefterFromConnectorModalWs from "./GetEdefterFromConnectorModalWs";
import SendToConnectorModal from "./SendToConnectorModal";
import SendToConnectorModalWs from "./SendToConnectorModalWs";
import HyundaiGetFromConnectorModalWs from "./HyundaiGetFromConnectorModalWs";

class ConnectorModal extends Component {
    _isMounted = false;

    constructor(props) {
        super(props);
        this.state ={
            connectionInfo:null
        };
    }

    componentDidMount() {
        this._isMounted = true;
        this.getConnectionInfo();
    }
    getConnectionInfo = async()=>{
        let self = this;
        let params = {
            url: `/connector/getConnectionInfo`,
            method: "post"
        };
        try{
            let {data} = await request(params);
            if(data!=null && this._isMounted){
                self.setState({connectionInfo:data});
            }
        }catch(error){
            let err = {response:{data:"Konnektör Bulunamadı"}}
            showAxiosError(err);
        }
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    render() {
        let {connectionInfo} = this.state;
        let {currentUser,type,modal,toggleModal,modalType,documentType} = this.props;
        let updateList = this.props.updateList ? this.props.updateList : ()=>{};
        return (
            <div>
                {modalType === "get" &&
                    <div>
                        {connectionInfo && connectionInfo.connectionType==="WINSERVICE" &&
                            <GetFromConnectorModal
                                modal={modal}
                                title="ERP'den Taslağa Aktarım"
                                type={type}
                                updateList={updateList}
                                toggleModal={toggleModal}
                            />
                        }

                        {(connectionInfo && connectionInfo.connectionType === 'WEBSOCKET' && connectionInfo.erpType && connectionInfo.erpType.name === 'HYUNDAI') &&
                            <HyundaiGetFromConnectorModalWs
                                modal={modal}
                                title="ERP'den Taslağa Aktarım"
                                type={type}
                                updateList={updateList}
                                connectionInfo={connectionInfo}
                                currentUser={currentUser}
                                toggleModal={toggleModal}
                            />
                        }

                        {(connectionInfo && connectionInfo.connectionType === 'WEBSOCKET' && connectionInfo.erpType && connectionInfo.erpType.name !== 'HYUNDAI' && type !== 'edefter') &&
                            <GetFromConnectorModalWs
                                modal={modal}
                                title="ERP'den Taslağa Aktarım"
                                type={type}
                                updateList={updateList}
                                connectionInfo={connectionInfo}
                                currentUser={currentUser}
                                toggleModal={toggleModal}
                            />
                        }
                        
                      {connectionInfo && connectionInfo.connectionType === 'WEBSOCKET' && type === 'edefter' &&
                          <GetEdefterFromConnectorModalWs
                              modal={modal}
                              title="ERP'den Edefter Aktarımı"
                              type={type}
                              updateList={updateList}
                              setTotalCount = {this.props.setTotalCount}
                              probableDefter = {this.props.probableDefter}
                              connectionInfo={connectionInfo}
                              currentUser={currentUser}
                              toggleModal={toggleModal}
                          />
                      }
                    </div>
                }
                {
                    modalType === "send" &&
                    <div>
                        {connectionInfo && connectionInfo.connectionType==="WINSERVICE" &&
                            <SendToConnectorModal
                                recordIdList={this.props.recordIdList}
                                modal={modal}
                                year={this.props.year}
                                month={this.props.month}
                                title="Fatura ERP Aktarımı"
                                toggleModal={toggleModal}
                            />
                        }
                        {connectionInfo && connectionInfo.connectionType === 'WEBSOCKET' &&
                            <SendToConnectorModalWs
                                documentType={this.props.documentType}
                                recordIdList={this.props.recordIdList}
                                recordType={this.props.recordType}
                                modal={modal}
                                year={this.props.year}
                                month={this.props.month}
                                title="Fatura ERP Aktarımı"
                                connectionInfo={connectionInfo}
                                currentUser={currentUser}
                                toggleModal={toggleModal}
                                send={this.send}
                            />
                        }
                    </div>
                }

            </div>

        )
    }
}

export default ConnectorModal;
